<!--
Phone number input component based on PrimeVue Dropdown and InputNumber components and libphonenumber-js library
-->
<template>
  <div class="flex p-0">
    <Dropdown
      id="countryCodeDropdown"
      v-model="selectedCountryCode"
      class="w-auto"
      filter
      :options="countriesCallingCode"
      :option-label="(item) => `${item.callingCode} (${item.countryCode})`"
    />
    <InputNumber
      id="phoneNumberInput"
      v-model="enteredPhoneNumber"
      class="flex-1"
      :min="0"
      :use-grouping="false"
    />
  </div>
</template>

<script>
import Dropdown from "primevue/dropdown";
import InputNumber from "primevue/inputnumber";
import {getCountriesCallingCode} from "@/shared/utils/phoneNumberUtils";

export default {
  name: "InputPhoneNumber",
  components: {Dropdown, InputNumber},
  props: {
    phoneNumberCountryCode: {
      type: String,
      default: null
    },
    phoneNumber: {
      type: String,
      default: null
    },
  },
  emits: ['update:phoneNumberCountryCode', 'update:phoneNumber'],
  computed: {
    countriesCallingCode() {
      return getCountriesCallingCode();
    },
    selectedCountryCode: {
      get() {
        if (typeof this.phoneNumberCountryCode === 'string') {
          return this.countriesCallingCode.find((item) => item.countryCode === this.phoneNumberCountryCode);
        }
        return this.phoneNumberCountryCode;
      },
      set(value) {
        if (value instanceof Object) {
          this.$emit('update:phoneNumberCountryCode', value.countryCode);
        } else {
          this.$emit('update:phoneNumberCountryCode', value);
        }
      }
    },
    enteredPhoneNumber: {
      get() {
        return !isNaN(parseInt(this.phoneNumber)) ? parseInt(this.phoneNumber) : null;
      },
      set(value) {
        this.$emit('update:phoneNumber', value?.toString());
      }
    }
  }
}
</script>

<style scoped lang="scss">
#countryCodeDropdown {
  background-color: $light-grey;
  border-radius: 3px 0 0 3px;
  border-right: 0.5px solid #ced4da;
}

:deep(.p-inputnumber-input) {
  border-radius: 0 3px 3px 0;
  border-left: 0.5px solid #ced4da;
}
</style>
